const firebaseConfig = {
    apiKey: "AIzaSyChEmj4Q4i6_lwTLr3wzo_iXi6qQ_nY_UY",
    authDomain: "health-care-website-55917.firebaseapp.com",
    projectId: "health-care-website-55917",
    storageBucket: "health-care-website-55917.appspot.com",
    messagingSenderId: "765977987283",
    appId: "1:765977987283:web:39c4d93c1cf8edfa0f6c26"
  };

  export default firebaseConfig;